import React, { useEffect, useState } from "react";
import TabManager from "../Tabs/TabManager";
import EmailSchedular from "./EmailSchedular/indexSchedule";
import EmailGroupList from "./EmailGroupList";
import ScheduleEmailsList from "./ScheduleEmailsList";
import { useLanguageContext } from "../../Context/LanguageContext";

export default function EmailIndex() {
  const [activeTab, setAciveTab] = useState(1);
  const { localization } = useLanguageContext();
  const [scheduleEmailDetails, setScheduleEmailDetails] = useState("");
  const [distributionGroup, setDistributionGroup] = useState(null);
  const [viewMode, setViewMode] = useState(false);
  const Tabs = [
    { id: 1, title: localization.tab1 },
    { id: 2, title: localization.tab2 },
    { id: 3, title: localization.tab3 },
  ];
  function handleTab(_id) {
    if (_id !== 2) {
      setScheduleEmailDetails("");
      setViewMode(false);
    }

    setAciveTab(_id);
  }

  return (
    <div id="content" className="mt-4 overflow-hidden">
      <TabManager
        activeTab={activeTab}
        tabs={Tabs}
        handleSelectTab={handleTab}
        tabPageName="EmailNotification"
      />
      {activeTab === 1 && (
        <EmailGroupList
          scheduleEmailDetails={setScheduleEmailDetails}
          setDistributionGroupList={setDistributionGroup}
        />
      )}
      {activeTab === 2 && (
        <EmailSchedular
          scheduleEmailDetails={scheduleEmailDetails}
          distributionGroupList={distributionGroup}
          viewMode={viewMode}
          activeTab={activeTab}
        />
      )}
      {activeTab === 3 && (
        <ScheduleEmailsList
          handleTab={handleTab}
          setScheduleEmailDetails={setScheduleEmailDetails}
          setViewMode={setViewMode}
        />
      )}
    </div>
  );
}
